import { FileEntry } from "../stores/files.store";

export interface NamingPattern {
  id: string;
  name: string;
  description: string;
  regex: RegExp;
  variables: PatternVariable[];
  example: string;
}

export interface PatternVariable {
  name: string;
  displayName: string;
  group: number;
}

export interface RenameRow {
  id: string;
  sourceFile: FileEntry;
  customInput: string;
  extractedVars: Record<string, string>;
  previewName: string;
  isValid: boolean;
  error?: string;
}

export enum RenameMode {
  TEMPLATE = 'template',
  DIRECT = 'direct',
  REGEX = 'regex'
}

export interface SavedTemplate {
  id: string;
  name: string;
  template: string;
  createdAt: number;
}

export interface RenameItem {
  path: string;
  oldName: string;
  newName: string;
  parentPath: string;
}

export interface RenameOperation {
  originalPath: string;
  newPath: string;
}

export interface RenameHistory {
  id: string;
  timestamp: number;
  operations: RenameOperation[];
}
